// extracted by mini-css-extract-plugin
export default {"steps":"_1pp728kb","greyDot":"_2S98RwTh","stepText":"_3bMGE6ee","stepTextLeft":"_50kzkQ_o","stepTextRight":"_20rK-uvT"};